import "@terapeuta-scss/appTerapeuta.scss";

/**
 * jQuery
 */
import $ from 'jquery';
window.$ = window.jQuery = $;

/**
 * Bootstrap
 */
import '../../public/terapeuta/js/bootstrap.bundle.min.js';

/**
 * GSAP
 */
import gsap from 'gsap';
window.gsap = gsap;

/* JS */
import "@terapeuta-js/parts/lazyloading";

import "./scripts";

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    window.location.reload();
  });
}
